module.exports = __webpack_public_path__ + "front/img/edm-banner.2be5b67c.png";